import React from 'react';
import {useTranslation} from 'react-i18next';
import {Row, Col} from 'reactstrap';
import {Select} from '@/Form';
import {buildSelectOptions} from '@/components/Form/formHelper';

const ClientPortfolio = () => {
  const {t: tr} = useTranslation('selection');

  return (
    <Row>
      <Col md={12}>
        <Row>
          <Col md={3}>
            <Select name='type' label={tr('report:type')}>
              {buildSelectOptions(tr('type_options'))}
            </Select>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default ClientPortfolio;
